export function systemAccessQueryKey(systemId: string | undefined) {
  return ["systemAccess", systemId] as const;
}
